// @flow

import MainApi from "./MainApi"
import IntlStore from "shared/stores/IntlStore"

export const BASE_URL = "order-admin-api/api"

export default {
  /*
    Order Search
     */
  orders: {
    findOrders: async ({ config }: { config: Object }): Promise<any> => {
      const { data } = await MainApi.get(`${BASE_URL}/orders`, config)
      return data
    },
    findOneById: async (id: string): Promise<any> => {
      const config = {
        headers: {
          "Accept-Language":
            IntlStore.currentLanguage === "no"
              ? "nb"
              : IntlStore.currentLanguage
        }
      }
      const { data } = await MainApi.get(`${BASE_URL}/orders/${id}`, config)
      return data
    },
    findVehicleOnMap: async (orderId: string, query: string): Promise<any> => {
      const { data } = await MainApi.get(
        `${BASE_URL}/orders/${orderId}/vehicle?${query}`
      )
      return data
    },
    findManageableForUser: async ({
      config
    }: {
      config: Object
    }): Promise<any> => {
      const { data } = await MainApi.get(
        `${BASE_URL}/orders/manageable`,
        config
      )
      return data
    },
    adminCompleteOrder: async (id: string, req: Object): Promise<any> => {
      const { data } = await MainApi.put(
        `${BASE_URL}/orders/${id}/status/admin-complete`,
        req
      )
      return data
    },
    AdminCancelOrder: async (id: string, req: Object): Promise<any> => {
      const { data } = await MainApi.put(
        `${BASE_URL}/orders/${id}/status/admin-cancel`,
        req
      )
      return data
    },
    getAllFleets: async (): Promise<any> => {
      const { data } = await MainApi.get(`${BASE_URL}/fleets`)
      return data
    },
    cancelOrder: async (id: string) => {
      await MainApi.delete(`${BASE_URL}/orders/${id}/cancel`)
    }
  }
}
